import {remCalc} from '../../theme/_utils'

export const getGradient = (variant, imageUrl) => {
    const gradient =
        variant === 'black'
            ? '(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)'
            : '(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)'
    return `linear-gradient(rgba${gradient}), url(${imageUrl})`
}

export const getHerobannerGradient = (desktopAlignment, variant, isMaskHeaderActive) => {
    if (!variant) return null
    const opacity = isMaskHeaderActive ? '0.5' : '0.2'
    const color = variant === 'white' ? '255, 255, 255' : '0, 0, 0'
    const alignmentDegrees = {
        'middle-left': 270,
        'middle-right': 90,
        'middle-center': 0,
        'top-center': 0,
        'bottom-center': 180,
    }

    const gradientTemplate = (deg) =>
        desktopAlignment === 'middle-center'
            ? `linear-gradient(${deg}deg, rgba(${color}, ${opacity}) 100%, rgba(${color}, ${opacity}) 100%)`
            : `linear-gradient(${deg}deg, rgba(${color}, 0) 0%, rgba(${color}, ${opacity}) 100%)`

    return gradientTemplate(alignmentDegrees[desktopAlignment] ?? 180)
}

export const getMediaHeight = (contentHeight) => {
    if (typeof contentHeight !== 'string' && typeof contentHeight !== 'number') return

    const heightMapping = {
        big: remCalc(800),
        mid: remCalc(640),
        small: remCalc(460),
        auto: 'auto',
    }

    return heightMapping[contentHeight] || remCalc(contentHeight)
}

export const getAlignmentStyles = (alignment = 'middle-center', styles) => {
    // Fallback to 'middle-center' in case alignment is of a falsy value
    return styles.alignment[alignment] || styles.alignment['middle-center']
}
export const calculateVerticalPadding = (direction, hasPaddings) => {
    if (direction === 'column') return 'unset'
    if (direction === '' && hasPaddings)
        return {
            base: remCalc(40),
            md: remCalc(24),
            lg: remCalc(0),
        }
    return remCalc(hasPaddings ? 40 : 0)
}
